import CreateNotification from "components/CreateNotification";
import DeleteNotification from "components/Modal/DeleteNotification";
import NotificationDetails from "components/Modal/NotificationDetails";
import NotificationDetailView from "components/NotificationDetailView";
import useDebounce from "hook/useDebounce";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ButtonComp from "themes/elements/Button";
import TabComp from "themes/elements/Tab";
import TableComp from "themes/elements/Table";
import { isPermit } from "utils/permissionCheck";
import { deleteNotification, fetchNotifications } from "../../api/notification";
import {
  draftscolumnHeaders,
  publishedColumnHeaders,
  scheduleColumnHeaders,
} from "./config";

function Notification() {
  const [isCreate, setCreate] = useState(false);
  const [detail, setDetail] = useState(false);
  const [dlt, setDlt] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isDuplicate, setDuplicate] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [selectedNotificationDetails, setSelectedNotificationDetails] =
    useState(null);

  //for showing all status pass 4 both published and  expired
  const [tabState, setTabstate] = useState(4);
  const [scheduledFlag, setScheduledFlag] = useState(null);
  const [totalPageNo, setTotalPageNo] = useState(0);
  const [selectedData, setSelectedData] = useState([]);
  const [tabActive, setTabActive] = useState("1");
  const [scheduledDetailPage, setScheduledDetailPage] = useState(false);

  // filters
  const [filterTitle, setFilterTitle] = useState(null);
  const [filterAlert, setFilterAlertDate] = useState(null);
  const [filterExpiry, setFilterExpiryDate] = useState(null);
  const [filterCode, setFilterCode] = useState(null);
  const [filterType, setFilterType] = useState(null);

  const loadNotifications = async () => {
    setIsLoading(true);
    try {
      const response = await fetchNotifications(
        currentPageNo,
        pageSize,
        tabState,
        scheduledFlag,
        filterTitle,
        filterAlert,
        filterExpiry,
        filterCode,
        filterType
      );
      if (response.meta?.last_page === 0 || response.meta?.last_page) {
        setTotalPageNo(response?.meta?.last_page * 10);
      }
      const formattedData = response.notification.map((item) => {
        const typeNum = Number(item.notification_type);
        const isAlert = typeNum === 2;
        const typeLabel = isAlert ? "Alert" : "General";
        return {
        title: item.notification_title,
        avatar: "svg/placeholder-for-avatar.svg",
        category: typeLabel,
        type: typeLabel,
        notification_type: Number.isFinite(typeNum) ? typeNum : undefined,
        recipients: ` ${item.wards?.length > 0 ? "Wards" : "All citizens"}`,
        recipients_flg: item.recipients_flg,
        created_user_name: item.created_user_name,
        author: item.created_user_name ?? "",
        alertdate: item.alert_date || null,
        status:
          item.content_status_flg === 1
            ? "Submitted"
            : item.content_status_flg === 2
            ? "Approved"
            : item.content_status_flg === 4
            ? "Published"
            : item.content_status_flg === 0
            ? "Draft"
            : item.content_status_flg === 5
            ? "Scheduled"
            : item.content_status_flg === 6
            ? "Expired"
            : item.content_status_flg === 3
            ? "Rejected"
            : "Draft",
        expirydate: item.expiry_date || null,
        publisheddate: item.alert_date || null,
        recipientsList: ` ${
          item.wards?.length > 0 ? `${item.wards}` : "All citizens"
        }`,
        content: item.notification_content,
        alert_date_time: item.alert_date_time,
        expiry_date_time: item.expiry_date_time,
        published_date_time: item.alert_date_time,
        id: item?.notification_content_id,
        wards: item?.wards,
        status_flg: item?.content_status_flg,
        allow_resubmission_flg: item?.allow_resubmission_flg,
        scheduled_flg: item?.scheduled_flg,
        start_date_time: item?.start_date_time,
        end_date_time: item?.end_date_time,
        destination_type: item?.redirection_type,
        destination:
          item?.redirection_type == null
            ? "None"
            : item?.redirection_type === 2
            ? "External"
            : item?.redirection_type === 0
            ? "None"
            : "In-app",
        external_link: item?.redirection_link,
        redirection_type: item?.redirection_type,
        display_us: item?.link_label,
        files: item?.files,
        activity: item?.activities,
        remarks: item?.approval_remarks,
      };
      });
      setNotifications(formattedData);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const debouncedLoadNotifications = useDebounce(loadNotifications, 300);

  useEffect(() => {
    debouncedLoadNotifications();
  }, [filterTitle, filterCode]);

  useEffect(() => {
    const goHome = () => {
      setCreate(false);
      setDetail(false);
      setScheduledDetailPage(false);
      setSelectedNotificationDetails(null);
      setEdit(false);
      setDuplicate(false);
      setDlt(false);
      setTabActive("1");
      setTabstate(4);
      setScheduledFlag(null);
    };
    window.addEventListener("app:notification-home", goHome);
    return () => window.removeEventListener("app:notification-home", goHome);
  }, []);

  useEffect(() => {
    loadNotifications();
  }, [
    currentPageNo,
    pageSize,
    isCreate,
    tabState,
    scheduledFlag,
    filterAlert,
    filterExpiry,
    filterType,
  ]);

  const DetailOpen = (data) => {
    setSelectedNotificationDetails(data);
    if (tabActive === "2") {
      setScheduledDetailPage(true);
      setDetail(false);
    } else {
      setScheduledDetailPage(false);
      setDetail(true);
    }
  };
  const handleEdit = (data) => {
    setSelectedNotificationDetails(data);
    setDuplicate(false);
    setEdit(true);
    setCreate(true);
    setDetail(false);
  };

  function handleTabChange(key) {
    let tabKey = Number(key);
    setSelectedData([]);
    setCurrentPageNo(1);
    setScheduledDetailPage(false);
    setDetail(false);
    setSelectedNotificationDetails(null);
    setTabActive(key);
    if (tabKey === 1) {
      setTabstate(4);
      setScheduledFlag(null);
    } else if (tabKey === 2) {
      setScheduledFlag(1);
      setTabstate(5);
    } else if (tabKey === 3) {
      setTabstate(0);
      setScheduledFlag(null);
    } else if (tabKey === 4) {
      setTabstate(1);
      setScheduledFlag(null);
    } else if (tabKey === 5) {
      setTabstate(3);
      setScheduledFlag(null);
    } else {
      setTabstate(4);
      setScheduledFlag(null);
    }
  }

  const handleDeleteNotification = async (data) => {
    setIsLoading(true);
    try {
      const response = await deleteNotification({
        notification_content_id: data,
      });
      if (response.message && response.statusCode === 200) {
        toast.success(response.message);
        setCurrentPageNo(1);
      } else {
        toast.error(response.message);
      }
      if (response) {
        setDlt(false);
        loadNotifications();
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const commonTableProps = {
    data: notifications,
    totalPageNo,
    currentPageNo,
    setCurrentPageNo,
    pageSize,
    setPageSize,
    isLoading,
    selectedData,
    setSelectedData,
    tabState,
    filterTitle,
    filterAlert,
    filterCode,
    filterExpiry,
    filterType,
    setFilterTitle,
    setFilterAlertDate,
    setFilterExpiryDate,
    setFilterCode,
    setFilterType,
    tabActive,
    dataClick: DetailOpen,
    handleEdit,
    onDeleteAction: (data) => {
      setSelectedNotificationDetails(data);
      setDlt(true);
    },
    copyAction: false,
    enableRowSelectionAndDelete: tabActive === "3",
    hideDeleteAction: tabActive !== "3",
  };

  const tabsData = [
    {
      key: "1",
      label: "Published",
      children: (
        <TableComp
          {...commonTableProps}
          column={publishedColumnHeaders}
          editAction={false}
          setStatus={(v) => setTabstate(v)}
        />
      ),
    },
    {
      key: "2",
      label: "Scheduled",
      children: (
        <TableComp
          {...commonTableProps}
          column={scheduleColumnHeaders}
          editAction={true}
        />
      ),
    },
    {
      key: "3",
      label: "Drafts",
      children: (
        <TableComp
          {...commonTableProps}
          column={draftscolumnHeaders}
          editAction={true}
        />
      ),
    },
    {
      key: "4",
      label: "Submitted",
      children: (
        <TableComp
          {...commonTableProps}
          column={draftscolumnHeaders}
          editAction={false}
        />
      ),
    },
    {
      key: "5",
      label: "Rejected",
      children: (
        <TableComp
          {...commonTableProps}
          column={draftscolumnHeaders}
          editAction={true}
          showEditOnlyWhenResubmission={true}
        />
      ),
    },
  ];

  return (
    <>
      {scheduledDetailPage && selectedNotificationDetails ? (
        <NotificationDetailView
          notification={selectedNotificationDetails}
          viewStatus={5}
          onCancel={() => {
            setScheduledDetailPage(false);
            setSelectedNotificationDetails(null);
          }}
          onEdit={() => {
            setScheduledDetailPage(false);
            handleEdit(selectedNotificationDetails);
          }}
          onDelete={() => {
            setScheduledDetailPage(false);
            setDlt(true);
          }}
        />
      ) : isCreate ? (
        <CreateNotification
          data={selectedNotificationDetails}
          selectedNotificationDetails={selectedNotificationDetails}
          setOpen={setCreate}
          isEdit={isEdit}
          isDuplicate={isDuplicate}
          handleTabChange={handleTabChange}
          approval={false}
          canPublishWithoutApproval={false}
        />
      ) : (
        <div className="page-wrapper flex flex-column gap-2">
          <div className="flex wrap gap-2 align-center justify-between">
            <h2 className="page-title">Notifications</h2>
            {isPermit(4, "create") && (
              <ButtonComp
                onClick={() => {
                  setEdit(false);
                  setDuplicate(false);
                  setSelectedNotificationDetails(null);
                  setCreate(true);
                }}
                prefix
              >
                Create notification
              </ButtonComp>
            )}
          </div>
          {isPermit(4, "view") && (
            <TabComp
              setDlt={setDlt}
              data={tabsData}
              exportData={selectedData}
              handleTabChange={handleTabChange}
              count={selectedData?.length}
              tabActive={tabActive}
            />
          )}
        </div>
      )}

      {selectedNotificationDetails && (
        <NotificationDetails
          loadNotifications={loadNotifications}
          handleCancel={() => setSelectedNotificationDetails(null)}
          open={detail}
          data={selectedNotificationDetails}
          setOpen={setDetail}
          tabState={tabState}
          onEdit={handleEdit}
        />
      )}
      <DeleteNotification
        isLoading={isLoading}
        selectedData={selectedData}
        data={selectedNotificationDetails}
        handleDeleteNotification={handleDeleteNotification}
        open={dlt}
        setOpen={setDlt}
      />
    </>
  );
}

export default Notification;
